// extracted by mini-css-extract-plugin
export var fullWidth = "roicalculator-module--fullWidth--934b4";
export var roiCalculatorContainer = "roicalculator-module--roiCalculatorContainer--e3aeb";